import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({ requiredPermission, component: Component, ...rest }) => {
  const { user, token } = useSelector((state) => state.signin);

  console.group(`--- Vérification ProtectedRoute pour : ${rest.path} ---`);

  return (
    <Route
      {...rest}
      render={(props) => {
        // 1. Si pas de token -> Login
        if (!token) {
          console.log("Résultat : Blocage (pas de token).");
          console.groupEnd();
          return <Redirect to="/sign-in" />;
        }

        // ==========================================================
        // FIX EXPERT : BYPASS ADMINISTRATEUR (ID 1)
        // ==========================================================
        if (user?.role?.id === 1) {
          console.log("Résultat : Accès autorisé (PROFIL ADMIN DÉTECTÉ).");
          console.groupEnd();
          return <Component {...props} />;
        }
        // ==========================================================

        // 2. Vérification des permissions pour les autres rôles
        if (requiredPermission) {
          if (!user?.permissions?.includes(requiredPermission)) {
            console.log(`Résultat : Blocage (permission '${requiredPermission}' manquante).`);
            console.groupEnd();
            return <Redirect to="/unauthorized" />;
          }
        }
        
        console.log("Résultat : Accès autorisé.");
        console.groupEnd();
        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;